import { render, staticRenderFns } from "./Scrap.vue?vue&type=template&id=6d284e44&"
import script from "./Scrap.vue?vue&type=script&lang=js&"
export * from "./Scrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports